import React, { useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import Navbar from "../../../shared/Navbar/Navbar";
import Footer from "../../../shared/Footer/Footer";
import OpenPositionDetailsBanner from "./OpenPositionDetailsBanner";
import ApplyPosition from "./ApplyPosition";
import { useCareersSection } from "../../../../context/CareersPageContext";
import { getPositionsFromSection } from "../../../../services/contentApi";

const OpenPositionDetails = () => {
  const { slug } = useParams();
  const { section, loading } = useCareersSection("open-positions");

  const positions = useMemo(
    () => (section?.fields ? getPositionsFromSection(section) : []),
    [section]
  );

  const job = useMemo(
    () => positions.find((item) => item.slug === slug) ?? null,
    [positions, slug]
  );

  if (loading || !section?.fields) return null;

  if (!job) {
    return <Navigate to="/careers" replace />;
  }

  return (
    <div>
      <Navbar />
      <OpenPositionDetailsBanner job={job} />
      <ApplyPosition job={job} section={section} />
      <Footer />
    </div>
  );
};

export default OpenPositionDetails;
